/* eslint-disable global-require */

import { ROLES } from '@/constants';
import admin from './roles/admin';
import municipality from './roles/municipality';
import region from './roles/region';
import support from './roles/support';

export default {
  computed: {
    navigation() {
      return {
        [ROLES.municipality]: municipality,
        [ROLES.support]: support,
        [ROLES.region]: region,
        [ROLES.admin]: admin,
      };
    },
  },
};
